import { IDeleteClienteUseCase } from "../../../presentation/useCases/delete/delete_cliente_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * DeleteClienteUseCase
 */

export class DeleteClienteUseCase implements IDeleteClienteUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idCliente: number): Promise<void> {
    return this.repository.deleteClienteById(idCliente);

  }
}
